const elevarCartProductList = [
  { type: 'mattress', list: '/collections/mattresses' },
  { type: 'base', list: '/collections/furniture' },
  { type: 'furniture', list: '/collections/furniture' },
  { type: 'pillow', list: '/collections/pillows' },
  { type: 'bedding', list: '/collections/blankets' },
  { type: 'sheets', list: '/collections/sheets' },
  // Compatibility alias for legacy/variant Shopify productType values.
  { type: 'sheet', list: '/collections/sheets' },
  { type: 'topper', list: '/collections/mattress-toppers' },
  { type: 'blanket', list: '/collections/blankets' },
];

export default elevarCartProductList;
